import React, { useState } from "react";
import {
  Gantt,
  Tasks,
  Column,
  Toolbar,
  Item,
  Validation,
  Editing,
} from "devextreme-react/gantt";
import "devextreme/dist/css/dx.light.css"; // Importar estilos necesarios
import _ from "lodash";
import { Form } from "react-bootstrap";

const TimelineResource = ({ user, dataFilter }) => {
  const [scaleType, setScaleType] = useState("days");

  const taskByUser = dataFilter?.filter((task) => {
    return task.IdUsuario == user.IdUsuario;
  });

  const projects = _.unionBy(taskByUser, "IdProyecto").map((pr) => {
    return {
      project: pr.Proyecto,
      IdProject: pr.IdProyecto,
    };
  });

  const allTaskAndProjects = taskByUser.concat(projects);
  const dataForTimeLine = allTaskAndProjects?.map((item) => {
    return {
      id: item.IdActividad ? item.IdActividad : item.IdProject,
      parentId: item.IdProyecto ? item.IdProyecto : 0,
      title: item.IdProyecto ? item.NombreActividad : item.project,
      start: item.IdProyecto ? item.vFechaInicio : "",
      end: item.IdProyecto ? item.vFechaFin : "",
    };
  });


  return (
    <>
      <div>
        <div>
          <Form.Control
            size="sm"
            as="select"
            value={scaleType}
            onChange={(e) => {
              setScaleType(e.target.value);
            }}
          >
            <option value="0">Seleccione escala de tiempo</option>
            <option value="days">Días</option>
            <option value="weeks">Semanas</option>
            <option value="months">Meses</option>
            <option value="years">Años</option>
          </Form.Control>
        </div>
      </div>
      <Gantt
        taskListWidth={500}
        scaleType={scaleType}
        height={400}
        onTaskDblClick={() => {
          return console.log("clickOnTask");
        }}
      >
        <Tasks dataSource={dataForTimeLine} />
        <Toolbar>
          <Item name="collapseAll" />
          <Item name="expandAll" />
          <Item name="separator" />
          <Item name="zoomIn" />
          <Item name="zoomOut" />
        </Toolbar>

        <Column dataField="title" caption="Nombre Actividad" width={300} />
        <Column
          dataField="start"
          caption="Fecha Inicio"
          minWidth={100}
          dataType="date"
          format="dd/MM/yyyy"
        />
        <Column
          dataField="end"
          caption="Fecha Fin"
          minWidth={100}
          dataType="date"
          format="dd/MM/yyyy"
        />

        <Validation autoUpdateParentTasks />
        <Editing disabled />
      </Gantt>
    </>
  );
};

export default TimelineResource;
